import React, { FunctionComponent, useState } from 'react';

import { Checkbox } from '@yandex-360/orb-components/dist/components/Checkbox';
import { Text } from '@yandex-360/orb-components/dist/components/Text';

import { ParticipantID } from '../../../pages/call/types';
import {
    muteAllRecordings as muteAllRecordingsAction,
    mutePeerRecording as mutePeerRecordingAction,
} from '../../features/moderation/slice';
import { i18n } from '../../helpers/i18n';
import { useActions } from '../../hooks';
import { OrbModalConfirm } from '../orb-modal-confirm';
import styles from './styles.css';

export interface ModalStopRecordingConfirmProps {
    participantId: ParticipantID | 'all';
    onClose(): void;
}

export const ModalStopRecordingConfirm: FunctionComponent<ModalStopRecordingConfirmProps> = ({
    onClose,
    participantId,
}) => {
    const { mutePeerRecording, muteAllRecordings } = useActions({
        mutePeerRecording: mutePeerRecordingAction,
        muteAllRecordings: muteAllRecordingsAction,
    });
    const [withoutRemoval, setWithoutRemoval] = useState(true);
    const isForAll = participantId === 'all';

    const handleConfirm = () => {
        if (isForAll) {
            muteAllRecordings(withoutRemoval);
        } else {
            mutePeerRecording({
                peerId: participantId,
                withoutRemoval,
            });
        }
        onClose();
    };

    return (
        <OrbModalConfirm
            title={
                isForAll
                    ? i18n('moderation', 'modal-stop-recordings-header')
                    : i18n('moderation', 'modal-stop-recording-header')
            }
            confirmLabel={i18n('moderation', 'modal-stop-recording-confirm-label')}
            cancelLabel={i18n('moderation', 'modal-stop-recording-cancel-label')}
            onConfirm={handleConfirm}
            onClose={onClose}
            onCancel={onClose}
            withContentWrapper={false}
        >
            <Text as="div" typography="body-short-md-regular" className={styles.description}>
                {i18n(
                    'moderation',
                    isForAll ? 'modal-stop-all-recordings-description' : 'modal-stop-recording-description'
                )}
            </Text>
            <div className={styles.checkboxWrapper}>
                <Checkbox
                    view="orb"
                    size="lg"
                    label={i18n(
                        'moderation',
                        isForAll
                            ? 'modal-stop-all-recordings-with-removal-label'
                            : 'modal-stop-recording-with-removal-label'
                    )}
                    checked={!withoutRemoval}
                    onChange={() => setWithoutRemoval((withoutRemoval) => !withoutRemoval)}
                />
            </div>
        </OrbModalConfirm>
    );
};
